// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchWrapper_root__1x5Tf","wrapper":"SearchWrapper_wrapper__2Dfh1","wrapperOpen":"SearchWrapper_wrapperOpen__F0EKi"};